import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c394522"),n=n(),_popScopeId(),n)
const _hoisted_1 = { for: "textoModelo" }
const _hoisted_2 = {
  key: 0,
  class: "erro"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createTextVNode(" Texto Modelo "),
    _createVNode(_component_ckeditor, {
      editor: _ctx.ClassicEditor,
      config: {},
      modelValue: _ctx.textoModeloString,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.textoModeloString) = $event)),
      onInput: _ctx.digitou
    }, null, 8, ["editor", "modelValue", "onInput"]),
    (_ctx.erroString)
      ? (_openBlock(), _createElementBlock("article", _hoisted_2, _toDisplayString(_ctx.erroString), 1))
      : _createCommentVNode("", true)
  ]))
}